<template>
  <div class="user-page" style="width: 100%">
    <AccessHandler
      :requiredRoleGroups="roleGroups"
      @accessChanged="(a: boolean) => (hasAccess = a)"
    />
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">MANAGE USER LOGINS</h1>
        </header>
        <div class="user-container">
          <UserTable />
        </div>
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import UserTable from "./UserTable.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { UserRoles as Roles } from "@/Domain/UserRoles";
import {
  type RoleGroup,
  RCorRcSupportStaffGroup,
  OUInternalStaff,
} from "@/shared/access/RoleGroups";
import { ref } from "vue";

const roleGroups = [
  {
    roles: [
      Roles.ROLE_IN_HOUSE_MIS_MANAGER,
      ...RCorRcSupportStaffGroup.roles,
      Roles.ROLE_EXTERNAL_CUSTOMER_ADMIN,
      ...OUInternalStaff.roles
    ],
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.user-container {
  margin: 10px 30px 30px;
  padding: 0;
  width: auto;
}
</style>
